export default __webpack_public_path__ + "static/media/vol.114c2e9e.svg";